export default "__VITE_ASSET__CSdtEjAe__ 640w, __VITE_ASSET__T$HMbouC__ 1024w";